import { all, takeLatest, put, call } from 'redux-saga/effects';
import ApiInstance from '../../../../helpers/apiInstance';
import actions from './actions';
import { tableConfig } from '../../../../settings/index';
import { sendRequest } from '../../../../helpers/saga';
import { logger } from '../../../../helpers/logger';
import notifications from '../../../../redux/notifications/actions';

const api = new ApiInstance('clients');

function* loadData(data) {
  try {
    const { page = 1, pageSize = tableConfig.pageSize, column, order, filter = '', ...filtersProps } = data.payload;
    let { district = [] } = data.payload;

    if (!Array.isArray(district)) {
      district = [district];
    }

    const result = yield call(
      sendRequest,
      api.get,
      {
        search: {
          page,
          pageSize,
          column,
          order,
          filter,
          ...filtersProps,
        },
      },
      notifications.REQUEST_ERROR,
    );

    if (result?.status === 200 && result?.data) {
      const { records, filters, totalCount, filteredCount, sortableColumns, saved_searches } = result.data;

      yield put(
        actions.loadDataSuccess({
          data: records,
          total: totalCount,
          filteredTotal: filteredCount,
          filters,
          sortableColumns,
          savedSearches: saved_searches,
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export { loadData };
export default function* rootSaga() {
  yield all([takeLatest(actions.LOAD, loadData)]);
}
